import React, { useRef } from "react";
import "./MeetTheTeam.css";

import pom from "./media/drparismita.jpeg";


export default function MeetTheTeam() {
  const sliderRef = useRef(null);

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: -350, // adjust step if needed
        behavior: "smooth",
      });
    }
  };

  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: 350, // adjust step if needed
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="meet-container">
      {/* Left Section */}
      <div className="meet-left">
        <h1>
          About Us
        </h1>
        <p className="meet-description">
PrimeMax is a modern dental clinic in Guwahati, built around one simple idea: exceptional dental care shouldn't feel clinical or rushed. Our team of experienced dentists and caring staff combines advanced technology with a calm, patient-first approach — whether you're in for a routine cleaning, a smile makeover, or complex restorative work. We're proud to be one of Guwahati's most trusted names in dental care, and every treatment plan we create is built around you, not a one-size-fits-all approach.
        </p>

        {/* <div className="meet-buttons">
          <button className="arrow-btn" onClick={handlePrev}>
            ←
          </button>
          <button className="arrow-btn" onClick={handleNext}>
            →
          </button>
        </div> */}
      </div>

      {/* Right Section (Team Cards) */}
      <div className="meet-right" ref={sliderRef}>
        <div className="team-card">
          <img src={pom} alt="Team Member" />
          <h2>Dr. Parismita Das</h2>
          <p>Dental surgeon</p>
          <span>
           Dr. Parismita Das is a highly-skilled Dental Surgeon specializing in smile makeovers and advanced cosmetic treatments.Her expertise encompasses a full spectrum of cosmetic procedures, including porcelain veneers, professional whitening, composite bonding, and full-mouth rehabilitation. Dr. Parismita combines artistry with the latest dental technology to create smiles that are both beautiful and perfectly functional.
          </span>
        </div>









        {/*  more cards  */}
      </div>
    </section>
  );
}
